import {
  compose,
  css,
  layout,
  LayoutProps,
  space,
  SpaceProps,
  variant,
} from '@wrisk/styled-system'
import styled from 'styled-components'

import { withDefaultProps } from '../../defaultProps'
import { TypoSizeProps, typoSizes } from '../typography'
import { wordBreak, WordBreakProps } from '../typography/wordBreak'

export type ListItemProperty = 'default' | 'bullet'

export interface ListItemProps
  extends LayoutProps,
    SpaceProps,
    WordBreakProps,
    TypoSizeProps {
  variant?: ListItemProperty
}

const defaultProps = withDefaultProps<ListItemProps>({
  variant: 'default',
})

export const ListItem = styled.li.attrs<ListItemProps>(defaultProps)(
  css({
    listStyleType: 'none',
    position: 'relative',
  }),
  variant({
    scale: 'ListItem',
    variants: {
      default: {},
      bullet: {
        pl: 6,
        '&::before': {
          content: '"•"',
          position: 'absolute',
          left: 0,
        },
      },
    },
  }),
  compose(layout, space, wordBreak, typoSizes),
)
